export enum DAY_TYPE_ID {
    NONE = 'none',
    PRE_POLLING_DAYS = 'prepoll',
    ELECTION_DAY = 'elecday',
    BOTH = 'both',
}
